import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControlLoad extends Layout {
    checkboxCheckDriverDepart: Checkbox;
    checkboxCheckLoadNumber: Checkbox;
    checkboxCreateEmpty: Checkbox;
    checkboxCreateEmptyOnDeliveryTrailerChange: Checkbox;
    checkboxCreateEmptyToLocation: Checkbox;
    checkboxDeliverLoad: Checkbox;
    checkboxDispatchLoad: Checkbox;
    checkboxGeocodeLocation: Checkbox;
    checkboxServiceIncidentNotification: Checkbox;
    checkboxShipper: Checkbox;
    checkboxUnassignRejectedLoad: Checkbox;
    checkboxUpdateArrival: Checkbox;
    checkboxUpdateBillOfLading: Checkbox;
    checkboxUpdateDeliveredClear: Checkbox;
    checkboxUpdateDeparture: Checkbox;
    checkboxUpdateDetentionDeparture: Checkbox;
    checkboxUpdateETA: Checkbox;
    checkboxUpdateMovementAccept: Checkbox;
    checkboxUpdatePalletsIn: Checkbox;
    checkboxUpdatePalletsOut: Checkbox;
    checkboxUpdatePieces: Checkbox;
    checkboxUpdateTrailer: Checkbox;
    checkboxUpdateWeight: Checkbox;
    checkboxUseAutoDeparture: Checkbox;
    panelLoadRowHeading: Panel;
    panelLoadRowOne: Panel;
    panelLoadRowThree: Panel;
    panelLoadRowTwo: Panel;
    panelLoadSection: Panel;
    sourceMCExAppControl: DataSource;
    textboxAcceptedField: Textbox;
    textboxArrivalDateField: Textbox;
    textboxArrivalTimeField: Textbox;
    textboxBillOfLadingField: Textbox;
    textboxDeliveredClearField: Textbox;
    textboxDepartDateField: Textbox;
    textboxDepartTimeField: Textbox;
    textboxDropTrailerField: Textbox;
    textboxETAAcceptedField: Textbox;
    textboxETAOrderNumberField: Textbox;
    textboxEmptyToLocationField: Textbox;
    textboxFormField: Textbox;
    textboxLoadNumberField: Textbox;
    textboxNewTrailerField: Textbox;
    textboxOldTrailerField: Textbox;
    textboxOrderNumberField: Textbox;
    textboxPalletsInField: Textbox;
    textboxPalletsOutField: Textbox;
    textboxPiecesField: Textbox;
    textboxStopIDField: Textbox;
    textboxUpdateOrder: Textbox;
    textboxWeightField: Textbox;
}
